import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import LogoShowcase from "./pages/LogoShowcase";
import SubmitInventory from "./pages/SubmitInventory";
import AmazonOverstock from "./pages/AmazonOverstock";
import ThemePreview from "./pages/ThemePreview";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/logos" element={<LogoShowcase />} />
          <Route path="/submit-inventory" element={<SubmitInventory />} />
          <Route path="/amazon-overstock" element={<AmazonOverstock />} />
          <Route path="/themes" element={<ThemePreview />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
